export const hotelsEn = {
  nav: {
    dashboard: 'Dashboard',
    settings: 'Settings',
    wakeupScheduling: 'Wake-Up Scheduling',
    wakeupHistory: 'Wake-Up History',
  },
  common: {
    unknown: 'Unknown',
    notAvailable: 'N/A',
    placeholder: '—',
    search: 'Search',
    entries: 'entries',
    show: 'Show',
    retry: 'Try again',
    loading: 'Loading',
    previous: 'Previous',
    next: 'Next',
    dayPlaceholder: 'Day...',
    timePlaceholder: 'Time...',
    filterTimesPlaceholder: 'Filter times...',
  },
  dialogs: {
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  errors: {
    loadRooms: 'Failed to load rooms',
    loadWakeupHistory: 'Failed to load wake-up history',
    loadPbxSettings: 'Failed to load PBX settings',
    loadExtensions: 'Failed to load extensions',
  },
  pagination: {
    previousPage: 'Previous page',
    nextPage: 'Next page',
    resultsPerPage: 'Results per page:',
    all: 'All',
    jumpToPage: 'Jump to page {{page}}',
    recordRange: '{{start}}—{{end}} of {{total}}',
    recordRangeEmpty: '0 of 0',
  },
  tableToolbar: {
    entriesOnly: '{{count}} entries',
    entriesFiltered: '{{filtered}} of {{total}} entries',
    resultsPerPage: 'Results per page:',
    showingSummary: 'Showing {{start}}-{{end}} of {{count}}',
  },
  datePresets: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    '1week': '1 Week',
    '2weeks': '2 Weeks',
    '3weeks': '3 Weeks',
    '4weeks': '4 Weeks',
    all: 'All',
  },
  wakeupStatus: {
    scheduled: 'Scheduled',
    tried: 'Tried',
    cleared: 'Cleared',
    canceled: 'Canceled',
  },
  dashboard: {
    incomingCallHistory: 'Incoming Call History',
    emergencyHistory: '911 History (7 Days)',
    roomStatus: 'Room Status',
    searchCalls: 'Search calls...',
    noIncomingCalls: 'No incoming calls',
    noMatchingCalls: 'No calls match your search',
    number: 'Number',
    name: 'Name',
    time: 'Time',
    destination: 'Dest.',
    room: 'Room',
    timeAndDate: 'Time & Date',
    duration: 'Duration',
    noEmergencyCalls: 'No Calls',
    emergencyFooter: '* Call placed to {{destination}}',
    refreshingIn: 'Refreshing in {{seconds}}s',
    noRoomsTitle: 'No rooms found',
    noRoomsDescription: 'No hospitality rooms are configured for this PBX.',
    resetRoomsSuccess: '{{count}} rooms reset to Dirty',
    resetRoomsFailed: 'Failed to reset rooms',
    roomStatusActions: {
      dirty: 'Dirty',
      clean: 'Clean',
      occupied: 'Occupied',
      inspected: 'Inspected',
    },
    roomTile: {
      openAria: 'Open room {{room}}',
    },
    roomDetail: {
      title: 'Room {{room}}',
      changeStatus: 'Change Status',
      cleanOrInspectedWarning:
        'Setting to Clean or Inspected will cancel active wake-up calls and clear voicemails.',
      activeWakeups: 'Active Wake-ups',
      voicemails: 'Voicemails',
      statusUpdated: 'Room status updated',
      statusUpdateFailed: 'Failed to update room status',
    },
    resetAllRooms: {
      button: 'Reset All Rooms to Dirty',
      title: 'Reset All Rooms',
      description:
        'This will set every room to Dirty status. Wake-up calls and voicemails will not be affected. Are you sure?',
      confirm: 'Reset All',
    },
    wakeupPopover: {
      title: 'Wake-Up Calls',
      manageAria: 'Manage wake-up calls',
      manageAriaPending: 'Manage wake-up calls (pending)',
      manageAriaCleared: 'Manage wake-up calls (cleared)',
      clearAll: 'Clear All?',
      clearAllSuccess: '{{count}} wake-up{{suffix}} canceled',
      clearAllFailed: 'Failed to clear wake-ups',
      scheduleSuccess: 'Wake-up call scheduled',
      scheduleFailed: 'Failed to schedule wake-up',
      addAria: 'Add wake-up call',
      loading: 'Loading...',
      none: 'No active wake-up calls',
      schedule: 'Schedule',
      cancelAria: 'Cancel wake-up',
      cancelAriaWithTime: 'Cancel wake-up at {{time}}',
    },
    voicemailPopover: {
      title: 'Voicemails',
      manageAria: 'Manage voicemails',
      manageAriaWithCount_one: 'Manage voicemails ({{count}} voicemail)',
      manageAriaWithCount_other: 'Manage voicemails ({{count}} voicemails)',
      clearAll: 'Clear All?',
      clearAllSuccess_one: '{{count}} voicemail cleared',
      clearAllSuccess_other: '{{count}} voicemails cleared',
      clearAllFailed: 'Failed to clear voicemails',
      loading: 'Loading...',
      none: 'No voicemails',
      status: 'Status',
      received: 'Received',
      from: 'From',
      read: 'Read',
      new: 'New',
      deleteAria: 'Delete voicemail',
      deleteSuccess: 'Voicemail deleted',
      deleteFailed: 'Failed to delete voicemail',
    },
  },
  wakeupScheduler: {
    scheduleSuccess: '{{count}} wake-up call{{suffix}} scheduled',
    scheduleFailed: 'Failed to schedule wake-up calls',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    scheduleWakeupCalls: 'Schedule Wake-Up Calls',
    scheduling: 'Scheduling...',
    selectedRooms: '{{count}} room{{suffix}} selected',
    cancelSuccess: 'Wake-up call canceled',
    cancelFailed: 'Failed to cancel wake-up call',
    addToPendingAria: 'Add to pending changes',
    pendingChanges: 'Pending Changes',
    noPendingChanges: 'No pending changes yet',
    applyChanges: 'Apply Changes',
    reset: 'Reset',
    noMatchingRooms: 'No matching rooms',
    noRoomsAvailable: 'No rooms available',
    roomNumber: 'Room Number',
    roomName: 'Room Name',
    status: 'Status',
    currentSchedule: 'Current Schedule',
    selectAllRooms: 'Select all rooms',
    selectRoom: 'Select room {{number}}',
    dayLabel: 'Day',
    timeLabel: 'Time',
    filterTimesLabel: 'Filter times',
    removePendingAria: 'Remove pending wake-up for room {{room}}, {{time}}',
    cancelWakeupAria: 'Cancel wake-up for room {{room}} at {{time}}',
  },
  history: {
    noHistory: 'No wake-up call history',
    noMatchingRecords: 'No matching records found',
    showing: 'Showing {{start}} to {{end}} of {{count}} entries',
    filteredFromTotal: '(filtered from {{total}} total entries)',
    room: 'Room',
    roomName: 'Room Name',
    attempts: 'Attempts',
    wakeupDateTime: 'Wake-up Date & Time',
    activationDateTime: 'Activation Date & Time',
    wakeupStatus: 'Wake-up Status',
    originator: 'Originator',
    originPhone: 'Phone',
    originPortal: 'Portal',
  },
  settings: {
    activation: 'Activation',
    searchRoomsOrNames: 'Search by room or name...',
    noMatchingExtensions: 'No extensions match your search',
    noExtensionsForPbx: 'No extension lines found for this PBX',
    active: 'Active',
    roomNumber: 'Room Number',
    extensionName: 'Extension Name',
    currentStatus: 'Current Status',
    roomActiveAria: 'Room {{number}} active',
    statusAtTime: '{{status}} ({{time}} - {{date}})',
    activated: 'activated',
    deactivated: 'deactivated',
    roomToggleStatus: 'Room {{roomNumber}} {{action}}',
    toggleHospitalityFailed: 'Failed to toggle hospitality',
    resetRoomsToDirty: 'Reset Rooms to Dirty',
    everyDayAt: 'Everyday @',
    manually: 'Manually',
    saveSchedule: 'Save',
    scheduleSaveFailed: 'Failed to update reset schedule',
    manualResetEnabled: 'Room status will be reset manually',
    dailyResetAt: 'Room status will reset daily at {{time}}',
  },
}

export type HotelsLocale = typeof hotelsEn
